<template>
  <div class="sidebar-wrapper">
    <div class="sidebar">
      <div class="sidebar__heading">
        <h3 class="sidebar__title">Host Information</h3>
        <span @click="closeSideboxHost()"
          ><svg
            width="30"
            height="30"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            /></svg
        ></span>
      </div>
      <div class="sidebar__description">
        <div>
          <div class="speaker__image">
            <img
              src="../assets/host-kritika.png"
              alt="host of event"
              class="hosts-photo-crop"
            />
          </div>
        </div>

        <h2>Kritika Rajbhandari</h2>
        <p class="speaker-position">
          <strong>Project Manager</strong>
        </p>
        <p class="speaker-company">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="#aeaeae"
          >
            <path
              fill-rule="evenodd"
              d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
              clip-rule="evenodd"
            /></svg
          >&nbsp;Leapfrog Technology
        </p>
        <br />
        <div>
          <p class="speaker-bio">
            Kritika is a PM at Leapfrog and also has QA experience of almost
            four years. Her expertise are Team Management, Communication,
            Leadership, Planning and Organization.
          </p>
          <ul>
            <li>
              <div>
                <a
                  href="https://www.linkedin.com/in/kritika-rajbhandari-47b958109/"
                  target="_blank"
                  ><svg
                    viewBox="0 0 119 119"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.1899 6.04279C9.00929 6.04279 3.66064 11.4146 3.66064 18.4751C3.66064 25.3796 8.84996 30.9046 16.876 30.9046H17.0313C25.3719 30.9046 30.5626 25.3796 30.5626 18.4751C30.4066 11.4146 25.3719 6.04279 17.1899 6.04279Z"
                    />
                    <path
                      d="M5.07422 40.7283H28.9896V112.679H5.07422V40.7283Z"
                    />
                    <path
                      d="M87.6906 39.0396C74.7891 39.0396 66.138 51.1628 66.138 51.1628V40.7283H42.2219V112.679H66.1366V72.4988C66.1366 70.3478 66.2926 68.2002 66.9245 66.662C68.6533 62.3667 72.5877 57.9169 79.1947 57.9169C87.8486 57.9169 91.3097 64.515 91.3097 74.1875V112.679H115.223V71.4237C115.223 49.3236 103.424 39.0396 87.6906 39.0396Z"
                    />
                  </svg>
                  https://www.linkedin.com/in/kritika rajbhandari</a
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "../main";
export default {
  name: "SideHostBar",
  methods: {
    closeSideboxHost() {
      bus.$emit("closeSideboxHost");
      document.body.classList.remove("overflow-fix");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.speaker-workplace {
  display: flex;
  align-items: center;
  margin: 2rem 0rem;
}
.speaker-company {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  color: var(--lighter-grey);
}
.speaker-arrow {
  width: 100%;
  display: block;
  position: absolute;
}
.speaker-bio {
  margin: 1rem 0rem 4rem 0rem;
}
h2 {
  color: var(--primary-color);
  margin-top: 1rem;
}
.speaker__image {
  margin: 0 auto;
}
.speaker__image img {
  text-align: center;
  margin-right: auto;
  width: 60%;
  position: relative;
}
.sidebar {
  max-width: 550px;
  margin-left: auto;
  background-color: var(--bg-black);
  box-sizing: border-box;
  color: var(--text-white);
  overflow: auto;
}
.sidebar__description {
  position: relative;
  padding: 0 2rem 2rem 2rem;
}
.sidebar-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.69);
}
.sidebar__heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 999;
  padding: 2rem;
  background-color: var(--bg-black);
}
.sidebar__heading span {
  cursor: pointer;
}
.speaker__image .speaker_image {
  text-align: center;
  margin-right: auto;
  width: 60%;
  position: relative;
}
.speaker__image {
  position: relative;
}
.speaker-arrow {
  left: 0;
  right: 0;
  width: 47%;
  bottom: 0;
  position: absolute;
  margin: auto;
  z-index: 999;
}
.sidebar__description ul {
  display: flex;
  flex-direction: column;
}
.sidebar__description ul li {
  display: flex;
  align-items: center;
  color: var(--primary-color);
}
.sidebar__description ul li a {
  color: var(--primary-color);
  display: flex;
  align-items: center;
  word-break: break-word;
}
.sidebar__description ul li a > svg {
  width: 20px;
  margin-right: 1rem;
  fill: var(--primary-color);
}
@media (max-width: 576px) {
  .sidebar {
    width: 100%;
    max-width: 100%;
  }
}
</style>
